<template>
  <div :class="'result-page-nav'">
      <div>
            <img src="./logo.png" alt="" class="logo cur" @click="logoFunc">
            <img src="../../../assets/images/3.png" alt="" class="corner-mark3">
        </div>
    <div :class="searchStyle==='brand'?'nav-search brand':'nav-search'" v-if="showSearch">
      <div class="ipt">
        <input type="text" @keyup.enter="simpleSearch" v-model="keyword">
        <a href="javascript:" class="icon" @click="simpleSearch"></a>
      </div>
      <a href="javascript:;" class="more" @click="advShowSearch">高级搜索</a>
      <bkSearchTab :visible="visible" @advHideSearch="advHideSearch"></bkSearchTab>
      <div :class=" visible ? 'search-tag cur' : 'search-tag'">
        <span v-for="(tag,index) in searchTag" :key="tag">{{tag}} <a-icon type="close" style="cursor: pointer" @click="deleteTag(index)" /></span>
      </div>
    </div>
    <div :class="slideShow?'navs hd':'navs'">
      <router-link to="/bk/literature" class="nv">文献导航</router-link>
      <a href="https://dhc.library.sh.cn/newspapermap/" target="_blank" class="nv">报馆地图</a>
      <a class="nv" href="javascript:;"
        @click="onRelation('http://data.library.sh.cn/entity/person/lfzuha6tvgzrh3wc', 'bk')"
      >报人关系</a>
      <router-link :to="{name:'textAnalysis', query:{selectAll: true}}" class="nv">文本分析</router-link>
      <router-link to="/bk/brandHome" class="nv">海派品牌</router-link>
      <span class="nv" v-if="!userInfo">
          <a :href="Common.registerUrl">注册</a>/<a href="javascript:;" @click="login">登录</a>
      </span>
      <span class="nv" v-else>
          <a href="javascript:;" @click="goDhcUc">
            <img class="user" src="/user1.png">{{Common.userInfo.userName}}
          </a> |
          <a href="javascript:;" @click="exit">退出</a>
      </span>
      <a href="javascript:" :class="slideShow?'menu-toggle cur':'menu-toggle'" @click="showSlide">
        <span></span>
        <span></span>
        <span></span>
      </a>
    </div>
    <div :class="slideShow?'menu-slide-box cur':'menu-slide-box'">
      <div class="s-logo">
          <img src="../../../assets/images/3.png" alt="" class="corner-mark2">
      </div>
      <div class="links">
        <div class="link-row">
          <div class="title">
            文<br/>献<br/>知<br/>识<br/>库
          </div>
          <div class="td">
            <div class="swipe-box">
                <swiper :options="swiperOptions">
                    <swiper-slide v-for="f in Math.ceil(swiperData1.length/3)" :key="f">
                        <a v-for="item in (f===(Math.ceil(swiperData1.length/3))?(swiperData1.length%3===0?3:swiperData1.length%3):3)"
                            :href="swiperData1[(f-1)*3+item-1].url" :key="item" target="_blank"
                        >
                            <span @mouseenter="handleHover($event,swiperData1[(f-1)*3+item-1])" @mouseleave="handleLeave">{{swiperData1[(f-1)*3+item-1].name}}</span>
                        </a>
                    </swiper-slide>
                </swiper>
            </div>
            <div class="more" v-if="swiperData1.length > 3">
                <a-icon type="left" class="prev1" style="font-size: 20px;margin-right: 10px"></a-icon>
                <a-icon type="right" class="next1" style="font-size: 20px;"></a-icon>
            </div>
          </div>
        </div>
        <div class="link-row">
          <div class="title">
            基<br/>础<br/>知<br/>识<br/>库
          </div>
          <div class="td">
            <div class="swipe-box">
                <swiper :options="swiperOptions2">
                    <swiper-slide v-for="f in Math.ceil(swiperData2.length/3)" :key="f">
                        <a v-for="item in (f===(Math.ceil(swiperData2.length/3))?(swiperData2.length%3===0?3:swiperData2.length%3):3)"
                            :href="swiperData2[(f-1)*3+item-1].url" :key="item" target="_blank"
                        >
                            <span @mouseenter="handleHover($event,swiperData2[(f-1)*3+item-1])" @mouseleave="handleLeave">{{swiperData2[(f-1)*3+item-1].name}}</span>
                        </a>
                    </swiper-slide>
                </swiper>
            </div>
            <div class="more" v-if="swiperData2.length > 3">
                <a-icon type="left" class="prev2" style="font-size: 20px;margin-right: 10px"></a-icon>
                <a-icon type="right" class="next2" style="font-size: 20px;"></a-icon>
            </div>
          </div>
        </div>
        <div class="link-row">
          <div class="title">
            本<br/>体<br/>词<br/>表
          </div>
          <div class="td">
            <div class="swipe-box">
                <swiper :options="swiperOptions3">
                    <swiper-slide v-for="f in Math.ceil(swiperData3.length/3)" :key="f">
                        <a v-for="item in (f===(Math.ceil(swiperData3.length/3))?(swiperData3.length%3===0?3:swiperData3.length%3):3)"
                            :href="swiperData3[(f-1)*3+item-1].url" :key="item" target="_blank"
                        >
                            <span @mouseenter="handleHover($event,swiperData3[(f-1)*3+item-1])" @mouseleave="handleLeave">{{swiperData3[(f-1)*3+item-1].name}}</span>
                        </a>
                    </swiper-slide>
                </swiper>
            </div>
            <div class="more" v-if="swiperData3.length > 3">
                <a-icon type="left" class="prev3" style="font-size: 20px;margin-right: 10px"></a-icon>
                <a-icon type="right" class="next3" style="font-size: 20px;"></a-icon>
            </div>
          </div>
        </div>
        <div class="link-row">
          <div class="title">
            工<br/>具
          </div>
          <div class="td">
            <div class="swipe-box">
                <swiper :options="swiperOptions4">
                    <swiper-slide v-for="f in Math.ceil(swiperData4.length/3)" :key="f">
                        <a v-for="item in (f===(Math.ceil(swiperData4.length/3))?(swiperData4.length%3===0?3:swiperData4.length%3):3)"
                            :href="swiperData4[(f-1)*3+item-1].url" :key="item" target="_blank"
                            :style="swiperData4.length <= 3 ? 'width: 27%;' : ''"
                        >
                            <span @mouseenter="handleHover($event,swiperData4[(f-1)*3+item-1])" 
                                @mouseleave="handleLeave" v-html="swiperData4[(f-1)*3+item-1].name"
                            ></span>
                        </a>
                    </swiper-slide>
                </swiper>
            </div>
            <div class="more" v-if="swiperData4.length > 3">
                <a-icon type="left" class="prev4" style="font-size: 20px;margin-right: 10px"></a-icon>
                <a-icon type="right" class="next4" style="font-size: 20px;"></a-icon>
            </div>
          </div>
        </div>
        <div class="link-row"></div>
        <div class="link-row">
            <div class="title">
                其<br/>他<br/>文<br/>献
            </div>
            <div class="td">
                <div class="swipe-box">
                    <swiper :options="swiperOptions5" ref="mySwiper5">
                        <swiper-slide v-for="f in Math.ceil(swiperData5.length/3)" :key="f">
                            <a v-for="(item,index) in (f===(Math.ceil(swiperData5.length/3))?(swiperData5.length%3===0?3:swiperData5.length%3):3)"
                                :href="swiperData5[(f-1)*3+item-1].url" :key="'mySwiper5'+index" target="_blank"
                                :style="swiperData5.length <= 3 ? 'width: 27%;' : ''"
                            >
                                <span v-if="!swiperData5[(f-1)*3+item-1].hoverEng" 
                                    v-html="swiperData5[(f-1)*3+item-1].name"
                                ></span>
                                <span v-else 
                                    @mouseenter="handleHover($event,swiperData5[(f-1)*3+item-1])" 
                                    @mouseleave="handleLeave" v-html="swiperData5[(f-1)*3+item-1].name"
                                ></span>
                            </a>
                        </swiper-slide>
                    </swiper>
                </div>
                <div class="more" v-if="swiperData5.length > 3">
                    <a-icon type="left" class="prev5" style="font-size: 20px;margin-right: 10px"></a-icon>
                    <a-icon type="right" class="next5" style="font-size: 20px;"></a-icon>
                </div>
            </div>
        </div>
      </div>
    </div>
    
    <div class="hover-tips" v-if="showHover && hoverTit" :style="'left:'+hoverX+'px;top:'+hoverY+'px'">
        <div class="tit">{{hoverTit}}</div>
        <p>{{hoverEng}}</p>
    </div>
  </div>
</template>

<script>
  import bkSearchTab from '../bkSearchTab/index'
  import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
  import 'swiper/css/swiper.css'
  export default {
    components: {
      bkSearchTab,
      Swiper,
      SwiperSlide
    },
    directives: {
      swiper: directive
    },
    data(){
      return{
        keyword: '',
        visible:false,
        logo1:'/pic/etl.png',
        tips:"/pic/tips.png",
        slideShow:false,
        userInfo:null,
        searchTag:[],
        showHover:false,
        hoverTit:'',
        hoverEng:'',
        hoverX:'',
        hoverY:'',
        swiperOptions:{
            slidesPerView: 'auto',
            spaceBetween: 10, // 间距
            freeMode: true,
            navigation: {
                nextEl: '.next1',
                prevEl: '.prev1',
                disabledClass: 'button-disabled'
            }
        },
        swiperOptions2:{
            slidesPerView: 'auto',
            spaceBetween: 2, // 间距
            freeMode: true,
            navigation: {
                nextEl: '.next2',
                prevEl: '.prev2',
                disabledClass: 'button-disabled'
            }
        },
        swiperOptions3:{
            slidesPerView: 'auto',
            spaceBetween: 10, // 间距
            freeMode: true,
            navigation: {
                nextEl: '.next3',
                prevEl: '.prev3',
                disabledClass: 'button-disabled'
            }
        },
        swiperOptions4:{
            slidesPerView: 'auto',
            spaceBetween: 10, // 间距
            freeMode: true,
            navigation: {
                nextEl: '.next4',
                prevEl: '.prev4',
                disabledClass: 'button-disabled'
            }
        },
        swiperOptions5:{
            slidesPerView: 'auto',
            spaceBetween: 10, // 间距
            freeMode: true,
            navigation: {
                nextEl: '.next5',
                prevEl: '.prev5',
                disabledClass: 'button-disabled'
            }
        },
        swiperData1:[
            {
                name:'家谱',
                id:'1',
                hoverTit:'中国家谱知识服务平台',
                hoverEng:'Chinese Genealogy Knowledge Service Platform',
                url:'//jiapu.library.sh.cn'
            },
            {
                name:'盛档',
                id:'2',
                hoverTit:'盛宣怀档案知识库',
                hoverEng:'Sheng Xuanhuai Archives Knowledge Base',
                url:'//sd.library.sh.cn'
            },
            {
                name:'古籍',
                id:'3',
                hoverTit:'中文古籍联合目录及循证平台',
                hoverEng:'Chinese Ancient Books Union Catalogue and Evidence-based Platform',
                url:'//gj.library.sh.cn'
            },
            {
                name:'红色文献',
                id:'4',
                hoverTit:'革命（红色）文献服务平台',
                hoverEng:'Revolutionary(Red) Document Service Platform',
                url:'//red.library.sh.cn'
            }
            // ,
            // {
            //     name:'舆图',
            //     id:'5',
            //     hoverTit:'',
            //     hoverEng:'',
            //     url:'//gj.library.sh.cn/yutu'
            // }
        ],
        swiperData2:[
            {
                name:'人物',
                id:'1',
                hoverTit:'人名规范库',
                hoverEng:'Name Authority Database',
                url:'//names.library.sh.cn'
            },
            {
                name:'姓氏',
                id:'2',
                hoverTit:'华人姓氏列表',
                hoverEng:'Chinese Surname List',
                url:'//data.library.sh.cn/familynames'
            },
            {
                name:'地名',
                id:'3',
                hoverTit:'地理名词表',
                hoverEng:'Geographic Names List',
                url:'//data.library.sh.cn/place/main'
            },
            {
                name:'机构',
                id:'4',
                hoverTit:'收藏机构名录',
                hoverEng:'Organizations Directory',
                url:'//data.library.sh.cn/organization/main'
            },
            {
                name:'时间',
                id:'5',
                hoverTit:'中国历史纪年表',
                hoverEng:'Chinese History Chronology',
                url:'//data.library.sh.cn/dynasty/main'
            },
            {
                name:'事件',
                id:'6',
                hoverTit:'历史文化事件',
                hoverEng:'Cultural Events',
                url:'//data.library.sh.cn/shnh/event/webapi/tolist'
            },
            {
                name:'印章',
                id:'7',
                hoverTit:'印章知识库',
                hoverEng:'Seal Knowledge Base',
                url:'//data.library.sh.cn/gj/webapi/toSealList'
            },
            {
                name:'建筑',
                id:'8',
                hoverTit:'建筑',
                hoverEng:'Architectures',
                url:'//data.library.sh.cn/shnh/wkl/webapi/building/toAllBuilding'
            },
        ],
        swiperData3:[
            {
                name:'CBDB',
                id:'1',
                hoverTit:'CBDB本体',
                hoverEng:'CBDB Ontology',
                url:'//data.library.sh.cn/ont/ontology/tree?g=http://ont.library.sh.cn/graph/cbdb'
            },
            {
                name:'电影',
                id:'2',
                hoverTit:'上海年华本体',
                hoverEng:'Shanghai Memory Ontology',
                url:'//data.library.sh.cn/ont/ontology/tree?g=http://ont.library.sh.cn/graph/shlmemo'
            },
            {
                name:'档案',
                id:'3',
                hoverTit:'手稿及档案本体',
                hoverEng:'Archive and Manuscripts Ontology',
                url:'//data.library.sh.cn/ont/ontology/tree?g=http://ont.library.sh.cn/graph/shlmarc'
            },
            {
                name:'家谱',
                id:'4',
                hoverTit:'家谱本体',
                hoverEng:'Genealogy Ontology',
                url:'//data.library.sh.cn/ont/ontology/tree?g=http://ont.library.sh.cn/graph/shlgen'
            },
            {
                name:'古籍',
                id:'5',
                hoverTit:'古籍本体',
                hoverEng:'Ancient book Ontology',
                url:'//data.library.sh.cn/ont/ontology/tree?g=http://ont.library.sh.cn/graph/shlancient'
            },
            {
                name:'书目',
                id:'6',
                hoverTit:'关联书目数据本体词表',
                hoverEng:'Linked Bibliographic Data Ontology Vocabulary',
                url:'//data.library.sh.cn/ont/ontology/tree?g=http://ont.library.sh.cn/graph/shlbib'
            }
        ],
        swiperData4:[
          {
                        name:'众包',
                        id:'1',
                        hoverTit:'历史文献众包平台',
                        hoverEng:'Historical Document Crowd-sourcing Platform',
                        url:'http://zb.library.sh.cn/'
                    },
                   
                    {
                        name:'家谱联编',
                        id:'2',
                        hoverTit:'家谱联合编目系统',
                        hoverEng:'Chinese Genealogy Union Cataloging System',
                        url:'http://jplb.library.sh.cn/'
                    },
                    // {
                    //     name:'&nbsp;ETL',
                    //     id:'2',
                    //     hoverTit:'ETL（Any2RDF）',
                    //     hoverEng:'',
                    //     url:'http://data.library.sh.cn/mrdsj/index.html'
                    // }
                    {
                        name:'文本分析',
                        id:'3',
                        hoverTit:'文本分析工具包平台',
                        hoverEng:'',
                        url:'https://tools.library.sh.cn'
                    },
                    {
                        name:'HGIS',
                        id:'4',
                        hoverTit:'HGIS支撑平台',
                        hoverEng:'',
                        url:'https://hgis.library.sh.cn'
                    }
                    ,
                    {
                        name:'SNS',
                        id:'5',
                        hoverTit:'SNS分析平台',
                        hoverEng:'',
                        url:'https://sns.library.sh.cn'
                    }
        ],
        swiperData5:[
            {
                name:'报刊',
                id:'1',
                hoverTit:'近代报刊资源库',
                hoverEng:'',
                url:'https://dhc.library.sh.cn/bk/home'
            },
            {
                name:'近代图书',
                id:'2',
                hoverTit:'中国近代图书全文数据库',
                hoverEng:'Books of Modern China (1840~1949)',
                url:'//jdts.library.sh.cn'
            }
        ]
      }
    },
    props:{
      fontColor:{
        default:''
      },
      searchStyle:{
        default:'normal'
      },
      showSearch:{
        default:true
      }
    },
    created(){
        this.loggingStatus();
    },
    mounted(){
      this.$nextTick(()=>{
        this.esc(this, 1);
      })
    },
    methods:{
      simpleSearch(){
          let _searchType  = 1;
          let _simpleParams = {
            searchType   : _searchType,
            sourceTypes  : [],
            types        : [],
            simpleKeyword: this.keyword
          }
          this.$router.push({
            name:"bkSearchResult",
            params:{
              searchType: _searchType,
              simpleParams: JSON.stringify(_simpleParams),
            }
          });
      },
      advShowSearch(){ // 高级检索框显示
          this.visible = true;
          this.$emit('bkSearchShow', this.visible)
      },
      advHideSearch(){ // 高级检索框隐藏
          this.visible = false;
          this.$emit('bkSearchHide', this.visible)
      },
      showSlide(){
        this.slideShow=!this.slideShow
        this.$emit('hideContent')
      },
      change(e){
        this.$emit('change',e.target.value)
      },
      removeFilter(index){
        this.$refs['filter'+index].className='hide'
      },
      deleteTag(index){
        this.searchTag.splice(index,1)
        this.$emit('deleteTag', this.searchTag)
      },
      logoFunc(){
        this.$router.push("/");
      },
      login(){ // 登录
          this.goLogin(this.Common.authorizeUrl);
      },
      exit(){ // 退出
          this.isExit();
      },
      loggingStatus(){ // 登录状态
          let token = this.getTokenFunc();  // 获取token
          this.getAccount(token); // 获取用户信息
      },
      goDhcUc(){ // 登陆后,点击用户名跳转页面
          let token = this.getTokenFunc();  // 获取token
          // window.location.href = "https://dhc.library.sh.cn/uc/?token=" + token;
          // window.open("https://dhc.library.sh.cn/uc/?token=" + token);
          window.open("https://dhc.library.sh.cn/user?token=" + token);
      },
      handleHover(e,item){
          this.showHover = true
          this.hoverTit = item.hoverTit
          this.hoverEng = item.hoverEng
          this.hoverX = e.clientX-100
          this.hoverY = e.clientY+40
      },
      handleLeave(){
          this.showHover = false
      },
      // onRelation(){ // 报人关系
      //   localStorage.RELATION_FROM = 'bk';
      //   localStorage.RELATIONURI  = 'http://data.library.sh.cn/entity/person/lfzuha6tvgzrh3wc';
      //   let newUrl = this.$router.resolve({path: '/relation'});
      //   window.open(newUrl.href, '_blank');
      //   // window.open('https://dhc.library.sh.cn/uc/relation.html?uri=http://data.library.sh.cn/entity/person/lfzuha6tvgzrh3wc&from=bk&token='+ this.getTokenFunc());
      // }
    }
  }
</script>

<style>
body{
    background-color: transparent!important;
}
/* 输入框自动完成功能 */
.ant-select-dropdown{
    width: 30rem!important;
    max-width: 700px!important;
    background-color: rgba(255, 255, 255, 0.9)!important;
}

.ant-select-dropdown-menu-item:hover:not(.ant-select-dropdown-menu-item-disabled){
    /* 鼠标悬浮背景色 */
    background-color: rgba(201, 201, 201, 0.3)!important;
}
.ant-select-dropdown-menu-item-active:not(.ant-select-dropdown-menu-item-disabled){
    /* 鼠标悬浮相同的内容背景色 */
    background-color: rgba(201, 201, 201, 0.3)!important;
}

.certain-category-search-dropdown .ant-select-dropdown-menu-item-group-title {
  color: #666;
  font-weight: bold;
}

.certain-category-search-dropdown .ant-select-dropdown-menu-item-group {
  border-bottom: 1px solid #f6f6f6;
}

.certain-category-search-dropdown .ant-select-dropdown-menu-item {
  padding-left: 16px;
}

.certain-category-search-dropdown .ant-select-dropdown-menu-item.show-all {
  text-align: center;
  cursor: default;
}

.certain-category-search-dropdown .ant-select-dropdown-menu {
  max-height: 300px;
}
</style>

<style scoped>
/* 输入框自动完成功能 */
.certain-category-search-wrapper
  >>> .certain-category-search.ant-select-auto-complete
  .ant-input-affix-wrapper
  .ant-input-suffix {
  right: 12px;
}
.certain-category-search-wrapper >>> .certain-search-item-count {
  position: absolute;
  color: #999;
  right: 16px;
}
.certain-category-search-wrapper
  >>> .certain-category-search.ant-select-focused
  .certain-category-icon {
  color: #108ee9;
}
.certain-category-search-wrapper >>> .certain-category-icon {
  color: #6e6e6e;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  font-size: 16px;
}
</style>

<style scoped lang="less">
  // /deep/ .tk-search-tab .main-box .tabs span:before{
  //   background: rgba(255, 255, 255, 0.9);
  // }
  .result-page-nav{
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: transparent;
    background-color: transparent;
    z-index: 10;
    .logo{
      margin: 20px;
      width: auto;
      height: 40px;
      flex-shrink: 0;
      @media(min-width: 1100px){
        height: 65px;
      }
      @media(min-width: 1400px){
        height: 68px;
      }
    }
    .nav-search{
      position: relative;
      flex-grow: 1;
      margin: 0 10px;
      display: flex;
      align-items: center;
      height: 28px;
      max-width: 500px;
      &.brand{
        height: 34px;
        .ipt{
          height: 34px;
          background: #fff;
          border-radius: 17px;
          border: 1px solid #aaa;
          .icon{
            width: 21px;
            height: 21px;
            background-image: url("./searchicon2.png");
          }
        }
        .more{
          color: #289edc;
          margin-left: 10px;
        }
      }
      .search-tag{
        position: absolute;
        top: 36px;
        left: 10px;
        &.cur{
          opacity: 0.1;
        }
        span{
          display: inline-block;
          background: #90adbd;
          height: 18px;
          line-height: 18px;
          padding: 0 5px 0 10px;
          border-radius: 9px;
          color: #fff;
          font-size: 12px;
          margin-right: 5px;
        }
      }
      .ipt{
        display: flex;
        height: 28px;
        border-radius: 12px;
        // background: #dcdddd;
        background: #fff;
        flex-grow: 1;
        padding: 0 10px;
        align-items: center;
        input{
          flex-grow: 1;
          line-height: 28px;
          height: 28px;
        }
        .icon{
          width: 18px;
          height: 18px;
          background-size: 100% 100%;
          background-image: url("./searchicon2.png");
        }
      }
      .more{
        font-size: 13px;
        width: 30px;
        color: #334b87;
        line-height: 1.3;
        margin-left: 20px;
      }
    }
    .navs{
      text-align: right;
      line-height: 34px;
      position: relative;
      z-index: 9;
      flex-shrink: 0;
      &.hd{
        .nv{
          display: none;
        }
      }
      .nv{
        color: #334b87;
        font-size: 15px;
        display: inline-block;
        margin: 0 10px;
        vertical-align: top;
        @media(min-width: 1400px){
          margin: 0 18px;
        }
        a{
          color: #334b87;
        }
        &:hover{
          opacity: .9;
        }
        .user{
          width: 36px;
          vertical-align: top;
          margin-right: 5px;
        }
      }
      .menu-toggle{
        display: inline-block;
        margin: 0 18px;
        width: 50px;
        height: 34px;
        vertical-align: top;

        span{
          display: block;
          margin: 4px 0 10px 0;
          height: 2px;
          width: 100%;
          background: #334b87;
          transition: transform .5s,color .5s;
        }
        &.cur{
          span{
            background: #334b87;
            &:nth-child(1){
              transform: translate(0,12px);
            }
            &:nth-child(3){
              transform: translate(0,-12px);
            }
          }
        }
      }
    }
  }
</style>
